import React from "react";

import "./banner.css";

import Slide from "react-reveal/Slide";

class Banner extends React.Component {
  render() {
    return (
      <div>
        <Slide bottom>
          <div className="banner-ctn">
            <h1 className="name">
              I'm <br />
              Krishnanand A
            </h1>
            <p className="caption">Web Dev</p>
            <p>This site is a little bit older visit my new website <a style={{ color: '#007AFF' }} href="https://nextjs-pfo-2024.vercel.app/"> Go to new site</a>
              <p >Info!: This domain will be updated with the new website after its ready for production 🚀.</p>
            </p>
          </div>
        </Slide>
      </div>
    );
  }
}

export default Banner;
